// @flow

import type {
  ForkEffect,
  Put,
}                   from 'redux-saga/effects';
import {
  put,
  takeEvery,
}                   from 'redux-saga/effects';
import resetAllData from '../../actions/resetAllData';
import { logout }   from '../../modules/auth/actions/logout';


// -----------------------------------------------------------------------------------------------------------------
// Listener
// -----------------------------------------------------------------------------------------------------------------

export function* clearSensitiveDataOnLogout(): Generator<ForkEffect, void, void> {

  yield takeEvery(logout, clearSensitiveData);

}


// -----------------------------------------------------------------------------------------------------------------
// Handlers
// -----------------------------------------------------------------------------------------------------------------

function* clearSensitiveData(): Generator<Put, void, void> {

  yield put(resetAllData());

}


// WEBPACK FOOTER //
// ./src/sagas/session/clearSensitiveDataOnLogout.js